import type { IconDef } from '../types';

export const vape: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M11.21 0C11.7299 0 12.1699 0.399961 12.21 0.919922L12.3896 3.07031H13C13.55 3.07031 14 3.52031 14 4.07031V8H17C17.55 8 18 8.45 18 9V23C18 23.55 17.55 24 17 24H6C5.45 24 5 23.55 5 23V9C5 8.45 5.45 8 6 8H6.99023V4.07031C6.99023 3.52031 7.44023 3.07031 7.99023 3.07031H8.59961L8.78027 0.919922C8.83032 0.399972 9.26031 0 9.78027 0H11.21ZM6.74023 21.7998L15.7305 22.1904L16.25 10.2002L7.25977 9.80957L6.74023 21.7998ZM9.09668 19.415C9.34664 18.7451 9.95662 18.3651 10.4766 18.5449C10.9966 18.7249 11.2166 19.4247 10.9766 20.0947C10.7365 20.7646 10.1166 21.1548 9.59668 20.9648C9.07693 20.7848 8.85699 20.0848 9.09668 19.415ZM9 5.07031V8H12V5.07031H9Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
};
